<template>
  <div>
    <info-section-card
      v-for="dataPO in listDataPO"
      :key="dataPO.supplierCompanyID"
      class="mb-5"
    >
      <template v-slot:header>
        {{L10n('po')}} - {{dataPO.supplierCompanyName}}
      </template>
      <info-section-table
        :data="getListRFQ2BySupplier(dataPO.supplierCompanyID)"
        :fields="columnsParts"
      >
        <template
          v-slot:cell-_includeInPo="{ row }"
        >
          <span class="icon-db" :class="{'is-false': !row._includeInPo, 'is-true': row._includeInPo}"></span>
        </template>
        <template
          v-slot:cell-price="{ row }"
        >
          {{row.price | toPriceCurrency(row.currencyTitle)}}
        </template>
      </info-section-table>
      <div class="row">
        <div class="col-4">
          <div v-if="dataPO.po">
            <span class="title">{{L10n('po')}}: </span>{{dataPO.po}}
          </div>
          <div v-if="dataPO.poDate">
            <span class="title">{{L10n('po-date')}}: </span>{{dataPO.poDate | toDate}}
          </div>
          <div v-if="dataPO.requestedDate">
            <span class="title">{{L10n('requested-date')}}: </span>{{dataPO.requestedDate | toDate}}
          </div>
          <div v-if="dataPO.orderRatingScoreText">
            <span class="title">{{L10n('order-rating-score')}}: </span>{{dataPO.orderRatingScoreText}}
          </div>
          <div v-if="dataPO.paymentTermTitle">
            <span class="title">{{L10n('payment-term')}}: </span>{{dataPO.paymentTermTitle}}
          </div>
        </div>
        <div class="col-8">
          <div v-if="dataPO.shipToCompanyName">
            <span class="title">{{L10n('ship')}}: </span>{{dataPO.shipToCompanyName}}
          </div>
          <div v-if="dataPO.shipToCompanyDetailCountry">
            <span class="title">{{L10n('ship-country')}}: </span>{{dataPO.shipToCompanyDetailCountry}}
          </div>
          <div v-if="dataPO.shipToContactName">
            <span class="title">{{L10n('ship-contact')}}: </span>{{dataPO.shipToContactName}}
          </div>
          <div v-if="dataPO.customerForwarderName">
            <span class="title">{{L10n('forwarder')}}: </span>{{dataPO.customerForwarderName}}
          </div>
        </div>
      </div>
    </info-section-card>
  </div>
</template>

<script>
export default {
  name: 'InfoParts',
  components: {
    'info-section-card': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Card.vue'),
    'info-section-table': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Table.vue')
  },
  props: {
    listRFQ2: { type: Array, required: true },
    listDataPO: { type: Array, required: true }
  },
  data () {
    return {
      columnsParts: [
        { title: this.L10n('include-in-po'), fieldName: '_includeInPo' },
        { title: this.L10n('part-sn'), fieldName: 'partSN' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('price'), fieldName: 'price' },
        { title: this.L10n('condition'), fieldName: 'conditionTitle' }
      ]
    }
  },
  methods: {
    getListRFQ2BySupplier (id) {
      return this.listRFQ2
        .filter(({ supplierCompanyID }) => {
          return supplierCompanyID === id
        })
    }
  }
}
</script>
